import { $http } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    list: [],
    links: {},
    meta: {},
    form: {
      id: null,
      cover: null,
      logo: null,
      name: null,
      phone: null,
      email: null,
      address: null,
      website: null,
      about: null,
      lat: null,
      lng: null,
    },
    adminForm: {
      id: null,
      name: null,
      phone: null,
      email: null,
      company_id: null,
      company_name: null, // Add company name to store
      image: null,
      password: null,
    },
  },
  mutations: {
    SET_COMPANY: (state, data) => {
      Object.assign(state.form, {
        id: data.id,
        cover: data.cover,
        logo: data.logo,
        name: data.name,
        phone: data.phone,
        email: data.email,
        address: data.address,
        website: data.website,
        about: data.about,
        lat: data.lat,
        lng: data.lng,
      });
    },
    STORE_COMPANY: (state, data) => state.list.unshift(data),
    SET_COMPANYS: (state, data) => {
      state.list = data.data;
      state.links = data.links;
      state.meta = data.meta;
    },
    UPDATE_COMPANY: (state, data) => {
      state.list = state.list.filter((item) => item.id !== data.id);
      state.list.unshift(data);
    },
    DELETE_COMPANY: (state, data) => {
      const item = state.list.find((item) => item.id === data);
      state.list.splice(state.list.indexOf(item), 1);
    },
    SET_ADMIN: (state, data) =>
      Object.assign(state.adminForm, {
        id: data.id,
        name: data.name,
        phone: data.phone,
        email: data.email,
        company_id: data.company ? data.company.id : null,
        company_name: data.company ? data.company.name : null, // Store company name with defensive check
        image: data.image,
        password: null,
      }),
    STORE_ADMIN: (state, data) => state.list.unshift(data),
    SET_ADMINS: (state, data) => {
      state.list = data.data;
      state.links = data.links;
      state.meta = data.meta;
    },
    UPDATE_ADMIN: (state, data) => {
      state.list = state.list.filter((item) => item.id !== data.id);
      state.list.unshift(data);
    },
    DELETE_ADMIN: (state, data) => {
      const item = state.list.find((item) => item.id === data);
      state.list.splice(state.list.indexOf(item), 1);
    },
  },
  getters: {
    company: (state) => {
      let company = new FormData();
      console.log(state.form.cover);
      company.append("cover", state.form.cover);
      company.append("logo", state.form.logo);
      company.append("name", state.form.name);
      company.append("email", state.form.email);
      company.append("address", state.form.address);
      company.append("website", state.form.website);
      company.append("about", state.form.about);
      company.append("phone", state.form.phone);
      company.append("lat", state.form.lat);
      company.append("lng", state.form.lng);
      return company;
    },
    admin: (state) => {
      let admin = new FormData();
      admin.append("name", state.adminForm.name);
      admin.append("phone", state.adminForm.phone);
      admin.append("email", state.adminForm.email);
      admin.append("company_id", state.adminForm.company_id);
      admin.append("image", state.adminForm.image);
      if (state.adminForm.password)
        admin.append("password", state.adminForm.password);
      return admin;
    },
  },
  actions: {
    async get({ commit }, { page, name }) {
      const { payload } = await $http.get(
        `admin/companies?page=${page}${name ? `&name=${name}` : ""}`
      );
      commit("SET_COMPANYS", payload);
    },
    async getAll() {
      const { payload } = await $http.get("admin/companies");
      return payload.data;
    },
    async searchCompanies(_, searchQuery) {
      const { payload } = await $http.get(
        `admin/companies?name=${searchQuery || ""}&per_page=50`
      );
      return payload.data;
    },
    async show({ commit }, id) {
      const { payload } = await $http.get(`admin/companies/${id}`);
      commit("SET_COMPANY", payload);
    },
    async store({ getters }) {
      return await $http.post("admin/companies", getters.company);
    },
    async update({ state, getters }) {
      return await $http.post(
        `admin/companies/${state.form.id}`,
        getters.company
      );
    },
    async delete(_, id) {
      return await $http.delete(`admin/companies/${id}`);
    },
    async getAdmins({ commit }, { page, name }) {
      const { payload } = await $http.get(
        `admin/companies-admins?page=${page}${name ? `&name=${name}` : ""}`
      );
      commit("SET_ADMINS", payload);
    },
    async getAllAdmins() {
      const { payload } = await $http.get("admin/all-companies-admins");
      return payload;
    },
    async showAdmin({ commit }, id) {
      const { payload } = await $http.get(`admin/companies-admins/${id}`);
      commit("SET_ADMIN", payload);
    },
    async storeAdmin({ getters, dispatch }) {
      const response = await $http.post(
        "admin/companies-admins",
        getters.admin
      );
      await dispatch("getAll");
      return response;
    },
    async updateAdmin({ state, getters }) {
      return await $http.post(
        `admin/companies-admins/${state.adminForm.id}`,
        getters.admin
      );
    },
    async deleteAdmin(_, id) {
      return await $http.delete(`admin/companies-admins/${id}`);
    },
  },
};
